module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/corp/corp.component.html
// module id = ./src/app/corp/corp.component.html
// module chunks = main